const FOCUSABLE_ELEMENTS_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

const getFirstFocusableElementOnPage = () => document.body.querySelector(FOCUSABLE_ELEMENTS_SELECTOR);

export default {
    getFirstFocusableElementOnPage,
};
